import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "ManageUserView" }

import { onMounted, ref, watchEffect } from "vue";
import { User, UserControllerService } from "../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment/moment";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserManageView',
  setup(__props) {

const store = useStore();
const currUser = store.state?.user?.loginUser;
const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  pageSize: 10,
  current: 1,
  userId: "",
  userName: "",
});

const loadData = async () => {
  const res = await UserControllerService.listUserByPageUsingPost(
    searchParams.value as any
  );
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载数据失败！ " + res.message);
  }
};

onMounted(() => {
  loadData();
});
// 监听分页变量，改变时更新页面
watchEffect(() => {
  loadData();
});

const columns = [
  {
    title: "ID",
    dataIndex: "userId",
  },
  {
    title: "用户名",
    dataIndex: "userAccount",
  },
  {
    title: "昵称",
    dataIndex: "userName",
  },
  {
    title: "手机号",
    dataIndex: "userPhone",
  },
  {
    title: "邮箱",
    dataIndex: "userMail",
  },
  {
    title: "注册时间",
    slotName: "createTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];
const router = useRouter();
const doSubmit = () => {
  searchParams.value = {
    ...searchParams.value,
    current: 1,
  };
};
const doUpdate = (user: User) => {
  router.push({
    path: `/user/edit/${user?.userId}`,
  });
};
const doDelete = async (user: User) => {
  if (user.userId == currUser.userId) {
    message.error("不能删除当前用户！");
    return;
  }
  const res = await UserControllerService.deleteUserUsingPost({
    id: user.userId,
  });
  if (res.code === 0) {
    // 更新页面
    message.success("删除用户成功！");
    await loadData();
  } else {
    message.error("删除用户失败！ " + res.message);
  }
};
const visible = ref(false);

const handleClick = () => {
  visible.value = true;
};
const handleCancel = () => {
  visible.value = false;
};
const resetPassword = async (user: User) => {
  const res = await UserControllerService.resetPassWordUsingPost({
    userAccount: user.userAccount,
    userPassword: "12345678",
    checkPassword: "12345678",
    userMail: user.userMail,
  });
  if (res.code === 0) {
    message.success("重置密码成功！新密码为：12345678");
  } else {
    message.error("重置密码失败！ " + res.message);
  }
};
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("h1", null, "管理用户", -1)),
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "userId",
              label: "用户ID",
              "label-col-flex": "80px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: searchParams.value.userId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.userId) = $event)),
                  placeholder: "用户ID"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "userName",
              label: "昵称",
              "label-col-flex": "70px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: searchParams.value.userName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.userName) = $event)),
                  placeholder: "昵称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              style: {"width":"50%"},
              type: "primary",
              onClick: doSubmit
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("提交 ")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_divider, { size: 0 }),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
      },
      onPageChange: onPageChange
    }, {
      createTime: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: ($event: any) => (doUpdate(record))
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("修改")
              ])),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              status: "danger",
              onClick: handleClick
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("删除")
              ])),
              _: 1
            }),
            _createVNode(_component_a_modal, {
              visible: visible.value,
              "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
              onCancel: handleCancel,
              onOk: ($event: any) => (doDelete(record))
            }, {
              title: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" 警告")
              ])),
              default: _withCtx(() => [
                _cache[8] || (_cache[8] = _createElementVNode("div", null, "确认删除用户？", -1))
              ]),
              _: 2
            }, 1032, ["visible", "onOk"]),
            _createVNode(_component_a_button, {
              status: "danger",
              onClick: ($event: any) => (resetPassword(record))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("重置密码 ")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"]),
    _createVNode(_component_a_space, null, {
      default: _withCtx(() => [
        _cache[10] || (_cache[10] = _createTextVNode("每页用户数量 ")),
        _createVNode(_component_a_input_number, {
          modelValue: searchParams.value.pageSize,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchParams.value.pageSize) = $event)),
          min: "1",
          placeholder: "每页用户数量",
          size: "large"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})